module.exports = __webpack_public_path__ + "static/media/telescope.a47f9923.svg";